import { useTranslation } from 'next-i18next'

import CurriculumDropdown from './CurriculumDropdown'

interface Props {
  handleOptionSelect: (chosenCurriculumName: string) => void
  currentCurriculum: string
  currentCurriculumCode: string
  unsetStateLabel?: string
  isLightNested?: boolean
}

export default function OverviewCurriculumDropdown({
  handleOptionSelect,
  currentCurriculum,
  currentCurriculumCode,
  unsetStateLabel,
  isLightNested,
}: Props): React.ReactElement {
  const { t } = useTranslation('curriculum')
  return (
    <div className="flex flex-col items-center space-y-1 pt-3 font-medium tracking-px">
      <span className="text-white -ml-2">{t('dropdownTitle')}</span>
      <CurriculumDropdown
        allowOverflow
        currentCurriculum={currentCurriculum}
        currentCurriculumCode={currentCurriculumCode}
        handleOptionSelect={handleOptionSelect}
        isLightNested={isLightNested}
        unsetStateLabel={unsetStateLabel}
      />
    </div>
  )
}
